import React from 'react';
import { Upload, FileText, Calendar, Clock, CheckCircle2, ChevronDown, Wallet, DollarSign, TrendingUp, BarChart3, Building2, Info } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// Card Revenue Data (Monthly Revenue in Millions, Jan-22 to Mar-25)
const cardRevenueData = [{
  month: 'Jan-22',
  revenue: 3.2
}, {
  month: 'Feb-22',
  revenue: 3.3
}, {
  month: 'Mar-22',
  revenue: 3.4
}, {
  month: 'Apr-22',
  revenue: 3.3
}, {
  month: 'May-22',
  revenue: 3.5
}, {
  month: 'Jun-22',
  revenue: 3.5
}, {
  month: 'Jul-22',
  revenue: 3.6
}, {
  month: 'Aug-22',
  revenue: 3.6
}, {
  month: 'Sep-22',
  revenue: 3.7
}, {
  month: 'Oct-22',
  revenue: 3.7
}, {
  month: 'Nov-22',
  revenue: 3.8
}, {
  month: 'Dec-22',
  revenue: 3.8
}, {
  month: 'Jan-23',
  revenue: 3.5
}, {
  month: 'Feb-23',
  revenue: 3.6
}, {
  month: 'Mar-23',
  revenue: 3.7
}, {
  month: 'Apr-23',
  revenue: 3.6
}, {
  month: 'May-23',
  revenue: 3.7
}, {
  month: 'Jun-23',
  revenue: 3.8
}, {
  month: 'Jul-23',
  revenue: 3.9
}, {
  month: 'Aug-23',
  revenue: 3.8
}, {
  month: 'Sep-23',
  revenue: 4.0
}, {
  month: 'Oct-23',
  revenue: 4.0
}, {
  month: 'Nov-23',
  revenue: 4.1
}, {
  month: 'Dec-23',
  revenue: 4.1
}, {
  month: 'Jan-24',
  revenue: 3.8
}, {
  month: 'Feb-24',
  revenue: 3.8
}, {
  month: 'Mar-24',
  revenue: 4.0
}, {
  month: 'Apr-24',
  revenue: 3.9
}, {
  month: 'May-24',
  revenue: 4.0
}, {
  month: 'Jun-24',
  revenue: 4.1
}, {
  month: 'Jul-24',
  revenue: 4.2
}, {
  month: 'Aug-24',
  revenue: 4.1
}, {
  month: 'Sep-24',
  revenue: 4.3
}, {
  month: 'Oct-24',
  revenue: 4.3
}, {
  month: 'Nov-24',
  revenue: 4.4
}, {
  month: 'Dec-24',
  revenue: 4.4
}, {
  month: 'Jan-25',
  revenue: 4.1
}, {
  month: 'Feb-25',
  revenue: 4.2
}, {
  month: 'Mar-25',
  revenue: 4.3
}];
// Days Beyond Terms Data
const dbtData = [{
  month: 'Oct-24',
  dbt: 7,
  industry: 12,
  yourAR: 3
}, {
  month: 'Nov-24',
  dbt: 6,
  industry: 11,
  yourAR: 2
}, {
  month: 'Dec-24',
  dbt: 5,
  industry: 10,
  yourAR: 2
}, {
  month: 'Jan-25',
  dbt: 10,
  industry: 10,
  yourAR: 4
}, {
  month: 'Feb-25',
  dbt: 8,
  industry: 9,
  yourAR: 3
}, {
  month: 'Mar-25',
  dbt: 6,
  industry: 9,
  yourAR: 2
}, {
  month: 'Apr-25',
  dbt: 9,
  industry: 9,
  yourAR: 3
}, {
  month: 'May-25',
  dbt: 8,
  industry: 9,
  yourAR: 2
}, {
  month: 'Jun-25',
  dbt: 7,
  industry: 9,
  yourAR: 2
}, {
  month: 'Jul-25',
  dbt: 7,
  industry: 9,
  yourAR: 3
}, {
  month: 'Aug-25',
  dbt: 3,
  industry: 10,
  yourAR: 3
}];
// Trade Payment Aging Data
const paidData = [{
  name: 'Current',
  value: 28500000
}, {
  name: '1-30',
  value: 1200000
}, {
  name: '31-60',
  value: 85000
}, {
  name: '61-90',
  value: 12000
}, {
  name: '91+',
  value: 3000
}];
const outstandingData = [{
  name: 'Current',
  value: 1650000
}, {
  name: '1-30',
  value: 180000
}, {
  name: '31-60',
  value: 15000
}, {
  name: '61-90',
  value: 5000
}, {
  name: '91+',
  value: 0
}];
// Trade Spend by Industry Data
const tradeSpendData = [{
  name: 'Paper & Pulp Manufacturing',
  value: 777000,
  color: '#4f46e5',
  percentage: 42
}, {
  name: 'Office Supplies & Equipment',
  value: 333000,
  color: '#10b981',
  percentage: 18
}, {
  name: 'Wholesale Distribution',
  value: 741000,
  color: '#9ca3af',
  percentage: 40
}];
// Payment Aging by Industry Data
const paymentAgingData = [{
  industry: 'Paper & Pulp Manufacturing',
  total: '$777K',
  trades: 12,
  current: 92,
  days1to30: 6,
  days31to60: 2,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Office Supplies & Equipment',
  total: '$333K',
  trades: 35,
  current: 95,
  days1to30: 5,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Wholesale Distribution',
  total: '$741K',
  trades: 95,
  current: 91,
  days1to30: 7,
  days31to60: 2,
  days61to90: 0,
  days91plus: 0
}];
export function FinancialsTab() {
  return <div className="space-y-6 mt-6" data-id="element-1243" data-mp="2uiyj6i8w4voz">
      {/* Financial Statement Analysis */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-1244" data-mp="2fotyqtoft1rm">
        <div className="flex justify-between items-start mb-8" data-id="element-1245" data-mp="2kmn7nuh4k9vl">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-1246" data-mp="210tryi1j6ypd">
            Financial Statement Analysis
          </h2>
          <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2.5 rounded-lg flex items-center gap-2 font-medium text-sm transition-colors" data-id="element-1247" data-mp="1x0ta0nf845dk">
            <Upload className="w-4 h-4" data-id="element-1248" data-mp="260g38lxsu4vj" />
            UPLOAD FINANCIAL STATEMENT
          </button>
        </div>

        {/* Financial Statement Box */}
        <div className="border border-gray-200 bg-gray-50 rounded-lg p-5 mb-8" data-id="element-1249" data-mp="2jyo61ahio0em">
          <p className="text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-1250" data-mp="2fxks4tj14eg1">
            Latest Financial Statement
          </p>
          <div className="flex items-center justify-between bg-white p-4 rounded border border-gray-200 shadow-sm" data-id="element-1251" data-mp="2ts4xi7u6l3f4">
            <div className="flex items-center gap-6" data-id="element-1252" data-mp="33o81zkci9e58">
              <div className="flex items-center gap-3" data-id="element-1253" data-mp="33oq5n21hyun6">
                <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center" data-id="element-1254" data-mp="2ypdgubr2fdhy">
                  <FileText className="w-5 h-5 text-indigo-600" data-id="element-1255" data-mp="35sttx1e7sp2c" />
                </div>
                <span className="font-semibold text-gray-900 text-lg" data-id="element-1256" data-mp="3ar54jecc33lm">
                  DM-Financial-Statement-2025-Q1
                </span>
              </div>
              <div className="h-6 w-px bg-gray-300" data-id="element-1257" data-mp="3fp6lntq78sug"></div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-1258" data-mp="3khhlkwkxwen0">
                <Calendar className="w-4 h-4" data-id="element-1259" data-mp="3pgazur81w9o8" />
                <span className="font-medium" data-id="element-1260" data-mp="3pfj3he6mq7ww">2025</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-1261" data-mp="3th4pbp155wj8">
                <Clock className="w-4 h-4" data-id="element-1262" data-mp="2bleeo6ym1as" />
                <span className="font-medium" data-id="element-1263" data-mp="2cmnwo8bufqe">Q1</span>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-1264" data-mp="79mxh94dy0m9">
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full border border-green-200" data-id="element-1265" data-mp="78btb8712qum">
                <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-1266" data-mp="291sx20s1f7k3" />
                <span className="text-green-700 font-medium text-sm" data-id="element-1267" data-mp="2945fef1pjjxo">
                  Completed
                </span>
              </div>
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-1268" data-mp="1wra0repdajmu">
                <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-1269" data-mp="1rsgwmcvz04zc" />
              </button>
            </div>
          </div>
        </div>

        {/* Ratio Cards - All 5 in one row */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-1270" data-mp="1mrsxt51i2juk">
          {/* Liquidity Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1271" data-mp="2kf1mf8wss90s">
            <div className="flex items-center gap-2 mb-4" data-id="element-1272" data-mp="2aiyfzquwxo81">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center" data-id="element-1273" data-mp="2alb46lr9kutj">
                <Wallet className="w-4 h-4 text-blue-600" data-id="element-1274" data-mp="25jvkax0toucq" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1275" data-mp="z4ujoe0urnzt">Liquidity</h3>
            </div>
            <div className="space-y-3" data-id="element-1276" data-mp="u46ulxw6ph88">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1277" data-mp="u7b7djnptlai">
                <span className="text-xs text-gray-600" data-id="element-1278" data-mp="1jvgm4ey14xn8">Current Ratio</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1279" data-mp="1otrt8hwxwu1r">2.85</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1280" data-mp="1au0bq777svj0">
                <span className="text-xs text-gray-600" data-id="element-1281" data-mp="1euj4c3gxm5m9">Quick Ratio</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1282" data-mp="22jbvznqitrb2">2.41</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1283" data-mp="27iy7nsqpazhr">
                <span className="text-xs text-gray-600" data-id="element-1284" data-mp="1tr9udm4pu4z7">Working Capital</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1285" data-mp="1tp76b7n4ilx4">$8.6M</span>
              </div>
            </div>
          </div>

          {/* Cash Flow Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1286" data-mp="2lho373xvgr40">
            <div className="flex items-center gap-2 mb-4" data-id="element-1287" data-mp="2qah7jqpfhxfk">
              <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center" data-id="element-1288" data-mp="etff1rcqp9c5">
                <DollarSign className="w-4 h-4 text-green-600" data-id="element-1289" data-mp="9vw0eqc4qujo" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1290" data-mp="ojqti7u1v0xa">Cash Flow</h3>
            </div>
            <div className="space-y-3" data-id="element-1291" data-mp="jl76s57mtl3v">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1292" data-mp="jm8jee4aqfnp">
                <span className="text-xs text-gray-600" data-id="element-1293" data-mp="3s1igf7tbwuom">Op. Cash Flow</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-1294" data-mp="3n25sskumvjkz">1.52</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1295" data-mp="5u240u8ywcpb">
                <span className="text-xs text-gray-600" data-id="element-1296" data-mp="twjdy147qgq">Free Cash Flow</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1297" data-mp="1h8o03dowf9a7">$2.4M</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1298" data-mp="1haijuoofovcp">
                <span className="text-xs text-gray-600" data-id="element-1299" data-mp="1c92yswm9aoub">CF Coverage</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1300" data-mp="2wou0trknbaf7">12.35</span>
              </div>
            </div>
          </div>

          {/* Profitability Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1301" data-mp="2mzsms6xnv33v">
            <div className="flex items-center gap-2 mb-4" data-id="element-1302" data-mp="2i1r3bkwbp1rv">
              <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center" data-id="element-1303" data-mp="2hz4w5mdcgoa6">
                <TrendingUp className="w-4 h-4 text-purple-600" data-id="element-1304" data-mp="2czjnulcab3ks" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1305" data-mp="292dtgr4aeb6m">Profitability</h3>
            </div>
            <div className="space-y-3" data-id="element-1306" data-mp="241g9qa3mp930">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1307" data-mp="1z2mxsm3zpq4y">
                <span className="text-xs text-gray-600" data-id="element-1308" data-mp="29l7el39igxg">Net Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1309" data-mp="27h3i35d5hx6">0.08</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1310" data-mp="3tebg8y9fkau3">
                <span className="text-xs text-gray-600" data-id="element-1311" data-mp="4s6lvhkf5en0">ROE</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1312" data-mp="9s1epqnr8eap">0.18</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1313" data-mp="eldrn3j2mwnm">
                <span className="text-xs text-gray-600" data-id="element-1314" data-mp="jjp0pc1jl34s">Gross Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1315" data-mp="jl043ar2s8vd">0.32</span>
              </div>
            </div>
          </div>

          {/* Efficiency Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1316" data-mp="3n0e8f1cv2iw1">
            <div className="flex items-center gap-2 mb-4" data-id="element-1317" data-mp="3s120zrgqn7sd">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center" data-id="element-1318" data-mp="tpdyvt6c04j">
                <BarChart3 className="w-4 h-4 text-orange-600" data-id="element-1319" data-mp="177os8e6ogxkf" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1320" data-mp="1c71ofpjfvgzo">Efficiency</h3>
            </div>
            <div className="space-y-3" data-id="element-1321" data-mp="38ag4aoby3wda">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1322" data-mp="389eibote5pgs">
                <span className="text-xs text-gray-600" data-id="element-1323" data-mp="33bcyh1o55m49">Inv. Turnover</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1324" data-mp="3hamf22g9ei8r">8.50</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1325" data-mp="3db3vba06cd7i">
                <span className="text-xs text-gray-600" data-id="element-1326" data-mp="2pjolkw62itm8">AR Turnover</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1327" data-mp="2kln58j0118eg">10.20</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1328" data-mp="2ycjldacrnx4m">
                <span className="text-xs text-gray-600" data-id="element-1329" data-mp="2yewcad0i5htt">DSO</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-1330" data-mp="2tl0fvezw030r">35.78</span>
              </div>
            </div>
          </div>

          {/* Solvency Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1331" data-mp="21v5fmnahqsxb">
            <div className="flex items-center gap-2 mb-4" data-id="element-1332" data-mp="1rqp0jw4u5fuk">
              <div className="w-8 h-8 bg-teal-50 rounded-lg flex items-center justify-center" data-id="element-1333" data-mp="1rp4584ap5svn">
                <Building2 className="w-4 h-4 text-teal-600" data-id="element-1334" data-mp="1wji6uofycw8r" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1335" data-mp="1hulzktlpzn97">Solvency</h3>
            </div>
            <div className="space-y-3" data-id="element-1336" data-mp="1msdp5gyw6xa8">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1337" data-mp="2ahggjgjbw4hx">
                <span className="text-xs text-gray-600" data-id="element-1338" data-mp="2fgjao5xrsqb4">Debt-to-Equity</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-1339" data-mp="2fegnrurwzdam">0.65</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1340" data-mp="20ld6zpm5d3ky">
                <span className="text-xs text-gray-600" data-id="element-1341" data-mp="25kgctc9ybdtz">Z-Score</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1342" data-mp="p3c38oevg08o">3.42</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1343" data-mp="u49mz5fj52ca">
                <span className="text-xs text-gray-600" data-id="element-1344" data-mp="1aa31sasvnax1">Int. Coverage</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1345" data-mp="1ac60rkc0cedw">18.50</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Card Revenue Metrics */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6" data-id="element-1346" data-mp="10iff0n79mi1w">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1347" data-mp="vmzz7ppp6c2u">
          Card Revenue Metrics
        </h2>

        {/* Summary Stats - More compact layout */}
        <div className="flex flex-wrap justify-between items-center gap-4 mb-6 bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-1348" data-mp="1o9kpsnycmk5c">
          <div className="flex flex-col" data-id="element-1349" data-mp="1j9gah196fvgp">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-1350" data-mp="1eby9py5bcmjs">
              $5.1M
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-1351" data-mp="7vmbjx2hr4o7">
              Annual Card Revenue
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-1352" data-mp="2vgc3upzcdvk"></div>
          <div className="flex flex-col" data-id="element-1353" data-mp="2el6152tlji40">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-1354" data-mp="2ei1ttwku4694">
              6.8K
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-1355" data-mp="2jgv8vtfrs5be">
              Transactions
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-1356" data-mp="2ta2gzm1w9zf6"></div>
          <div className="flex flex-col" data-id="element-1357" data-mp="2y8n9ezawnet2">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-1358" data-mp="2y7ki4q9o7acm">
              $750
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-1359" data-mp="327w3y6drrgpo">
              Avg Ticket Size
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-1360" data-mp="3c8erpc8gfhcv"></div>
          <div className="flex flex-col" data-id="element-1361" data-mp="3c5itrnwlwsof">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-1362" data-mp="1cvswx44oqwu5">
              0 - 28
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-1363" data-mp="1hune61n08dc5">
              Daily Transactions
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-1364" data-mp="15rufeukq00qr"></div>
          <div className="flex flex-col" data-id="element-1365" data-mp="15tnpykygf541">
            <span className="text-2xl font-bold text-green-600 mb-0.5" data-id="element-1366" data-mp="1jrvimgogjk9e">
              +6%
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-1367" data-mp="1erzln1e6gt3c">
              YoY Growth
            </span>
          </div>
        </div>

        {/* Area Chart */}
        <div className="h-80 w-full" data-id="element-1368" data-mp="1oqyog3c9huif">
          <ResponsiveContainer width="100%" height="100%" data-id="element-1369" data-mp="1opx9hns4knvf">
            <AreaChart data={cardRevenueData} margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 0
          }} data-id="element-1370" data-mp="22id9sgtn67sn">
              <defs data-id="element-1371" data-mp="2ch2pc2y2fg5q">
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1" data-id="element-1372" data-mp="2cg9fuu7q2cjw">
                  <stop offset="5%" stopColor="#4f46e5" stopOpacity={0.3} data-id="element-1373" data-mp="27i7x6ae7kf8y" />
                  <stop offset="95%" stopColor="#4f46e5" stopOpacity={0} data-id="element-1374" data-mp="2r26q02yyzo8g" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1375" data-mp="2v30jdbv6lv8q" />
              <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} interval={3} dy={10} data-id="element-1376" data-mp="2m3n4u4s7agh5" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 8]} ticks={[0, 2, 4, 6, 8]} tickFormatter={value => `$${value}M`} data-id="element-1377" data-mp="1ye18rq74khdd" />
              <Tooltip formatter={(value: any) => `$${Number(value).toFixed(1)}M`} contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              padding: '12px'
            }} data-id="element-1378" data-mp="1tdwnznz6p0hc" />
              <Area type="monotone" dataKey="revenue" stroke="#4f46e5" strokeWidth={3} fillOpacity={1} fill="url(#colorRevenue)" activeDot={{
              r: 6,
              fill: '#4f46e5',
              stroke: '#fff',
              strokeWidth: 2
            }} data-id="element-1379" data-mp="1zy484nq96wxz" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Trade Payment Information */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8" data-id="element-1380" data-mp="177vkwhgv1mcj">
        {/* Trade Credit */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 lg:col-span-2" data-id="element-1381" data-mp="1280wqlogzav6">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1382" data-mp="s53ypncaocv9">Trade Credit</h2>
          <div className="grid grid-cols-2 gap-x-6 gap-y-4" data-id="element-1383" data-mp="x3oxdibweohl">
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-1384" data-mp="x245y1kvrlny">
              <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-1385" data-mp="123tijlnr47e5">
                $50K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-1386" data-mp="171ctabl8q21c">
                Recommended Credit Limit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-1387" data-mp="ed7b9wlkmr57">
              <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-1388" data-mp="eb385gvhxw5z">3</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-1389" data-mp="japlrrf8lefb">
                Days Beyond Terms
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-1390" data-mp="3mt0nw0cs7igz">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-1391" data-mp="3mqwnvti073lz">
                142
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-1392" data-mp="3rpr5wt85co51">
                Trade Experiences
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-1393" data-mp="1stc98hj92wor">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-1394" data-mp="1xthtvdr3rixc">
                $1.85M
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-1395" data-mp="21vbph7mfxwqn">
                Total Trades Balance
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-1396" data-mp="156dwnuy948w4">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-1397" data-mp="1a4p5q3gq2fda">
                $275K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-1398" data-mp="1e3o9hkqpw635">
                Recent High Credit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-1399" data-mp="me1j0c25dl6o">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-1400" data-mp="mbyww3448c78">
                $13.0K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-1401" data-mp="qdaepmgqzt4v">
                Average Credit Amount
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-1402" data-mp="dy3zwhyio8ht">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-1403" data-mp="9v7cmdy17o7j">
                $12.5K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-1404" data-mp="4x5rlnh1petf">
                Past Due
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-1405" data-mp="3w48iedsz1j34">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-1406" data-mp="3raw9dc0rzkvh">
                0.7%
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-1407" data-mp="3mdnpn6zzb8s4">
                Past Due %
              </span>
            </div>
            <div className="flex flex-col" data-id="element-1408" data-mp="3i969dhstvdm3">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-1409" data-mp="3dcfswtd42g05">$0</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-1410" data-mp="38dcz652kzw7h">
                Severely Past Due
              </span>
            </div>
            <div className="flex flex-col" data-id="element-1411" data-mp="2yoo60tkqwiil">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-1412" data-mp="33ok7om5yzxuz">0%</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-1413" data-mp="33mh75876ymc0">
                Severely Past Due %
              </span>
            </div>
          </div>
        </div>

        {/* Days Beyond Terms Chart */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 flex flex-col lg:col-span-3" data-id="element-1414" data-mp="2ts7erqi91o1a">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-3 gap-3" data-id="element-1415" data-mp="3mf1vqdfuy5a0">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-1416" data-mp="37q5js5aok844">
              Days Beyond Terms
            </h2>
            <div className="flex flex-wrap items-center gap-3 text-xs bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100" data-id="element-1417" data-mp="3coyszlixpcyh">
              <div className="flex items-center gap-2" data-id="element-1418" data-mp="48n9lr7fqp0j">
                <div className="w-5 h-0.5 border-t-2 border-dashed border-gray-400" data-id="element-1419" data-mp="905e2p8o37q9"></div>
                <span className="font-medium text-gray-600" data-id="element-1420" data-mp="91zuprcwodoj">Industry</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1421" data-mp="1to7rjq27m32q">
                <div className="w-5 h-0.5 bg-gray-900" data-id="element-1422" data-mp="1oqoc4mtrzk97"></div>
                <span className="font-medium text-gray-900" data-id="element-1423" data-mp="23g3zrty0f9ko">DBT</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1424" data-mp="1yhakpx32raie">
                <div className="w-5 h-0.5 bg-indigo-600" data-id="element-1425" data-mp="1yhss9pv6tb5m"></div>
                <span className="font-medium text-indigo-600" data-id="element-1426" data-mp="1ar6jtxh9tov3">Your AR</span>
              </div>
            </div>
          </div>
          <p className="text-xs text-gray-500 mb-6 max-w-md leading-relaxed" data-id="element-1427" data-mp="15twvym9j5l9d">
            Compare how they pay the industry, how they pay their vendors
            generally, and how they pay you.
          </p>
          <div className="flex-1 min-h-[250px] w-full mt-auto" data-id="element-1428" data-mp="1fp83okmits7m">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1429" data-mp="2v6s1p87icize">
              <LineChart data={dbtData} margin={{
              top: 5,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-1430" data-mp="2v9e9n8yb90i5">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1431" data-mp="3qh6ncejgm80c" />
                <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} dy={10} data-id="element-1432" data-mp="3viw1i31zb1sn" />
                <YAxis axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} domain={[0, 15]} ticks={[0, 5, 10, 15]} data-id="element-1433" data-mp="d9ddwr7h73w7" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                padding: '12px'
              }} data-id="element-1434" data-mp="s1x8v4kh252k" />
                <Line type="monotone" dataKey="industry" name="Industry" stroke="#9ca3af" strokeWidth={2} strokeDasharray="5 5" dot={false} activeDot={{
                r: 6,
                fill: '#9ca3af'
              }} data-id="element-1435" data-mp="2cgtq1q17tnxc" />
                <Line type="monotone" dataKey="dbt" name="DBT" stroke="#111827" strokeWidth={2} dot={false} activeDot={{
                r: 6,
                fill: '#111827'
              }} data-id="element-1436" data-mp="2v9eg6zpj5exg" />
                <Line type="monotone" dataKey="yourAR" name="Your AR" stroke="#4f46e5" strokeWidth={3} dot={false} activeDot={{
                r: 6,
                fill: '#4f46e5'
              }} data-id="element-1437" data-mp="3e6yw3habh35x" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Trade Payment Aging */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-1438" data-mp="tjp3gtld7qjp">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 gap-4" data-id="element-1439" data-mp="tlterwllfru0">
          <div data-id="element-1440" data-mp="xixye1s55ugu">
            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1441" data-mp="jl9d4su5wlb9">
              Trade Payment Information
            </h2>
            <div className="flex items-center gap-3 text-sm" data-id="element-1442" data-mp="ojkl0y0wclqu">
              <span className="font-medium text-gray-900 bg-gray-100 px-2.5 py-1 rounded-md" data-id="element-1443" data-mp="om715m1us9ko">
                Total Trade Lines: 142
              </span>
              <span className="text-gray-500" data-id="element-1444" data-mp="2ix2botwllyq3">
                Updated Monthly - Next Update 04/01/2026
              </span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto mb-10 border border-gray-200 rounded-xl" data-id="element-1445" data-mp="2czywzkh2x03">
          <table className="w-full text-left border-collapse" data-id="element-1446" data-mp="h1cv9xnh2hv4">
            <thead data-id="element-1447" data-mp="h2o3qarv4dsk">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1448" data-mp="caefr0ab5nsx">
                <th className="px-6 py-4 text-sm font-bold text-gray-900" data-id="element-1449" data-mp="c81qs364ud6d">
                  Status
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1450" data-mp="l2gdurwwms01">
                  Current
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1451" data-mp="zynwvowktndq">
                  1-30
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1452" data-mp="v1dyhjr7m1dr">
                  31-60
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1453" data-mp="2wrz7ewvo49j0">
                  61-90
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1454" data-mp="2azlebkzont41">
                  91+
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-100" data-id="element-1455" data-mp="2fwbus9fegqpz">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1456" data-mp="2pmoc7srx43rw">
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-1457" data-mp="1rzxr96lm3v3m">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-1458" data-mp="1s1sa8fdbpd52">
                  Paid
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1459" data-mp="1x0vf9ztazjd1">
                  $28,500,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1460" data-mp="2608iwbuqxdpu">
                  $1,200,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1461" data-mp="3dcip2ac8lsc5">
                  $85,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1462" data-mp="3hd2mzg4mwzzc">
                  $12,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1463" data-mp="11px9ae0y0a18">
                  $3,000
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-1464" data-mp="wyoybdjysgly">
                  $29,800,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-1465" data-mp="ryb1ysrq6v3r">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-1466" data-mp="n2m02is8h24a">
                  Outstanding
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1467" data-mp="i4aqm95uotml">
                  $1,650,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1468" data-mp="91jdm4xbtpsu">
                  $180,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1469" data-mp="28dcdc9bi1999">
                  $15,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1470" data-mp="23fu38flqwnzo">
                  $5,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1471" data-mp="2tmv9n8ilcmnd">
                  $0
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-1472" data-mp="32h9yo2sxbbjo">
                  $1,850,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-1473" data-mp="2ygpzyuspbzvf">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-1474" data-mp="2ardi76jb6jhi">
                  Payment Experiences
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1475" data-mp="25tc2mvl3d2as">
                  112
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1476" data-mp="2erxhafnfzx6a">
                  22
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1477" data-mp="3v5nwoik0i7v8">
                  5
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1478" data-mp="3q62mfbze6d37">
                  2
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1479" data-mp="2hxiewk1tx4g">
                  1
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-1480" data-mp="6ln9bso74qsn">
                  142
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Bar Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-1481" data-mp="l9go5b5gjpa6">
          {/* Paid Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1482" data-mp="q8bd6uu0qa2q">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-1483" data-mp="qae7hr27epd9">
              <div className="w-2 h-6 bg-green-600 rounded-full" data-id="element-1484" data-mp="bhaxc4qxzdwk"></div>
              Paid History
            </h3>
            <div className="h-64 w-full" data-id="element-1485" data-mp="gg5fr5kzz0g5">
              <ResponsiveContainer width="100%" height="100%" data-id="element-1486" data-mp="147t0t6vkvhai">
                <BarChart data={paidData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-1487" data-mp="18ysvs6l4zpad">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1488" data-mp="1dwzx7yyhu9gt" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-1489" data-mp="14vjk3jgant8w" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-1490" data-mp="q5kmbhsnijty" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(1)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-1491" data-mp="c7dyyvlbw28j" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '31-60') fill = '#84cc16';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-1493" data-mp="1qc7nyvtwupws" />;
                }} data-id="element-1492" data-mp="294s55g08z6kr" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Outstanding Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1494" data-mp="fo5wjopmgos7">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-1495" data-mp="am6uci5mbxwu">
              <div className="w-2 h-6 bg-blue-600 rounded-full" data-id="element-1496" data-mp="olg87b6cqfxn"></div>
              Outstanding Balance
            </h3>
            <div className="h-64 w-full" data-id="element-1497" data-mp="klxmid6pi0tr">
              <ResponsiveContainer width="100%" height="100%" data-id="element-1498" data-mp="2qduknuq4ms6o">
                <BarChart data={outstandingData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-1499" data-mp="2qg71u5o28yio">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1500" data-mp="2gafkxk8isnrg" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-1501" data-mp="27hvsx2mqhhfl" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-1502" data-mp="1jk6k1vjur600" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(2)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-1503" data-mp="3ixkfvtzzmgge" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '31-60') fill = '#84cc16';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-1505" data-mp="hz5pdyijhjmf" />;
                }} data-id="element-1504" data-mp="42s6ckycxa5u" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      {/* Trade Spend by Industry Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1506" data-mp="188wk3b9jtbmt">
        {/* Trade Spend Donut Chart */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-1" data-id="element-1507" data-mp="1i0k7n12zi8j0">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1508" data-mp="1mznemr2iyotm">
            Trade Spend by Industry
          </h2>
          <div className="relative h-64 w-full mb-8" data-id="element-1509" data-mp="1rz013aphhtvo">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1510" data-mp="1s0kw11fpneu2">
              <PieChart data-id="element-1511" data-mp="1vzjzehlsn3je">
                <Pie data={tradeSpendData} cx="50%" cy="50%" innerRadius={70} outerRadius={100} paddingAngle={2} dataKey="value" stroke="none" data-id="element-1512" data-mp="1w0uza6c4br58">
                  {tradeSpendData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1513" data-mp="2ma3g0kvt1wa9" data-mpi={index} />)}
                </Pie>
                <Tooltip formatter={(value: any) => `$${(value / 1000).toFixed(0)}K`} contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }} data-id="element-1514" data-mp="1yltyvw9jdwpg" />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-1515" data-mp="1ftiz4ba6ievk">
              <span className="text-2xl font-black text-gray-900" data-id="element-1516" data-mp="1au6gy3u95vzb">$1.85M</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1517" data-mp="3mi1grlfkelxv">
                Total Spend
              </span>
            </div>
          </div>

          {/* Custom Legend */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-1518" data-mp="3dhvb2lq3yq99">
            {tradeSpendData.map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-1519" data-mp="3hioyldzn231m" data-mpi={index}>
                <div className="w-3 h-3 rounded-full" style={{
              backgroundColor: item.color
            }} data-id="element-1520" data-mp="93n9ryvsa55k"></div>
                <span className="text-sm text-gray-600" data-id="element-1521" data-mp="e0doahrxwsov">
                  {item.name} {item.percentage}%
                </span>
              </div>)}
          </div>
        </div>

        {/* Payment Aging by Industry */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-2" data-id="element-1522" data-mp="2ksy1d6zyq1s4">
          <div className="flex justify-between items-center mb-8" data-id="element-1523" data-mp="2pskezhjpdk1g">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-1524" data-mp="29lkczhrvgimp">
              Payment Aging by Industry
            </h2>
            <div className="flex bg-gray-100 rounded-lg p-1" data-id="element-1525" data-mp="2ecsmedt7c3zv">
              <button className="px-3 py-1 text-sm font-medium bg-white shadow-sm rounded-md text-gray-900" data-id="element-1526" data-mp="2eediw8z2tx0d">
                %
              </button>
              <button className="px-3 py-1 text-sm font-medium text-gray-500 hover:text-gray-900" data-id="element-1527" data-mp="24lo9rkr00v87">
                $
              </button>
            </div>
          </div>

          <div className="space-y-6" data-id="element-1528" data-mp="2xb4zgan8hy0q">
            {paymentAgingData.map((item, index) => <div key={index} className="flex flex-col gap-2" data-id="element-1529" data-mp="2idw0aurovpyg" data-mpi={index}>
                <div className="flex justify-between items-end" data-id="element-1530" data-mp="2idmab76n9isr">
                  <span className="text-sm font-medium text-gray-700" data-id="element-1531" data-mp="2nc5xfawz50mp">
                    {item.industry}
                  </span>
                  <span className="text-sm text-gray-500" data-id="element-1532" data-mp="16xe3uuo3dnbt">
                    {item.total} ({item.trades})
                  </span>
                </div>
                {/* Stacked Bar */}
                <div className="h-6 w-full flex rounded-sm overflow-hidden" data-id="element-1533" data-mp="3q400vbs9i0xy">
                  {item.current > 0 && <div style={{
                width: `${item.current}%`
              }} className="bg-[#16a34a] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1534" data-mp="3l8kqwuxdkp6t">
                      {item.current > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1535" data-mp="32g8ok86q1nwo">
                          {item.current}%
                        </span>}
                    </div>}
                  {item.days1to30 > 0 && <div style={{
                width: `${item.days1to30}%`
              }} className="bg-[#84cc16] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1536" data-mp="3bfdonixxlpay">
                      {item.days1to30 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1537" data-mp="rnxz37wifngc">
                          {item.days1to30}%
                        </span>}
                    </div>}
                  {item.days31to60 > 0 && <div style={{
                width: `${item.days31to60}%`
              }} className="bg-[#facc15] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1538" data-mp="11czfgz6yw6uu">
                      {item.days31to60 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1539" data-mp="imzw8sxt5lzc">
                          {item.days31to60}%
                        </span>}
                    </div>}
                  {item.days61to90 > 0 && <div style={{
                width: `${item.days61to90}%`
              }} className="bg-[#f59e0b] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1540" data-mp="1u0llsf7kxple">
                      {item.days61to90 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1541" data-mp="2zvui7q67bwr3">
                          {item.days61to90}%
                        </span>}
                    </div>}
                  {item.days91plus > 0 && <div style={{
                width: `${item.days91plus}%`
              }} className="bg-[#dc2626] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1542" data-mp="2qtlcddlvork1">
                      {item.days91plus > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1543" data-mp="f5lns33blynj">
                          {item.days91plus}%
                        </span>}
                    </div>}
                </div>
              </div>)}
          </div>

          <div className="mt-8 text-center border-t border-gray-100 pt-4" data-id="element-1544" data-mp="2yz4fd4fvv09k">
            <button className="text-indigo-600 text-sm font-medium hover:text-indigo-700 uppercase tracking-wider" data-id="element-1545" data-mp="2z18ivl9vdx9b">
              Show More
            </button>
          </div>
        </div>
      </div>
    </div>;
}